module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-select solo"
  }, [_c('div', {
    staticClass: "selected row",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.display()
      }
    }
  }, [(_vm.select) ? _c('div', {
    staticClass: "content-select row"
  }, [(_vm.select.firstname || _vm.select.first_name) ? _c('div', {
    staticClass: "ctn-profile-picture"
  }, [_c('img', {
    directives: [{
      name: "img-detect",
      rawName: "v-img-detect"
    }],
    attrs: {
      "src": _vm.getPicture(_vm.select),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.select.firstname || _vm.select.first_name) ? _c('span', {
    attrs: {
      "title": (_vm.select.firstname || _vm.select.first_name) + ' ' + (_vm.select.lastname || _vm.select.last_name)
    }
  }, [_vm._v(_vm._s(_vm.select.firstname || _vm.select.first_name) + " " + _vm._s(_vm.select.lastname || _vm.select.last_name))]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "v-else"
  }, [_vm._v("\n\t\t\t \n\t\t")]), _vm._v(" "), (!_vm.innerDisabled) ? _c('span', {
    staticClass: "icon-arrow-full-down",
    class: {
      deploy: _vm.show
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.items), function(client, key) {
    return _c('div', {
      key: key,
      staticClass: "item row",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setSelect(key)
        }
      }
    }, [(client !== '-') ? _c('div', {
      staticClass: "ctn-profile-picture"
    }, [_c('img', {
      directives: [{
        name: "img-detect",
        rawName: "v-img-detect"
      }],
      attrs: {
        "src": _vm.getPicture(client),
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(client.firstname || '-') + " " + _vm._s(client.lastname))])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13d97761"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Form/CustomSelectUser.vue
// module id = 1072
// module chunks = 0